import constants from './constants';

export const customizeDistance = (distance: number, unit?: string) => {
  return unit === constants.DISTANCE_UNITS.MILES
    ? distance * constants.DISTANCE_UNITS.MULTIPLIER
    : distance;
};
